<template>
  
<div id="app"> 

  <div class="fixed">
    <div class="header">
      <appHeader class="logo"></appHeader>
          
      <appGenre class="genre"
      v-on:moveToteennovel="moveToteen"
      v-on:moveToscifi="moveToscifi"
      v-on:moveTofantasy="moveTofantasy"
      v-on:moveTosocialwelfare="moveTosocial"
      v-bind:genreActive="genreIsActive"></appGenre>
      
      <appConnection class="connection>"></appConnection>

    </div>

    <div class="keyword">
     
      <appInput 
            v-on:clickSearch="searchBooks" 
            v-on:tossKeywords="searchBooks"
            v-on:addKeywords="handleRecommendKeywords" 
            v-bind:buttonIsActive="searchIsActive"
            class="inputBox"></appInput>
     
      <appKeywords class="keywordsBoard" 
            v-on:clickKeyword="clickRecommendKeyword"
            v-on:recommendBooks ="showRecommendbooks"
            v-on:btnAllbooks="showAllbooks"
            v-on:cancleKeyword="renewCurrentKeywords"
            v-bind:defaultKeywords="defaultkeywords"
            v-bind:recommendKeywords="recommendkeywords"
            v-bind:currentkeywords="currentKeywords">
      </appKeywords>
    </div>
  </div>


  <div class="mainSection">
    <appList v-on:clickKeywords="searchBooks"
            v-on:clickKeywordsOnlist="handleRecommendKeywords"
            v-on:offImg="switchingImgAndSpec"
            v-on:onImg="switchingImgAndSpec"
            v-bind:propsdata="currentBooks"
            v-bind:genreAcitve="genreIsActive"
            class="bookBoard"></appList>

    <appPaging 
            v-on:movePage="fetchData"
            v-on:firstPage="goFirstpage"
            v-on:lastPage="goLastpage"
            v-on:previousPage="minusCurrentpage"
            v-on:nextPage="plusCurrentpage"
            v-bind:totalpages="allPages"
            v-bind:currentpage="currentPage"
            class="pagination"></appPaging>

    <appFooter class="footer"></appFooter>   

  </div> 

</div>

</template> 

<script>

import axios from 'axios'
import appHeader from './components/appHeader.vue'
import appGenre from './components/appGenre.vue'
import appConnection from './components/appConnection.vue'

import appInput from './components/appInput.vue' 

import appKeywords from './components/appKeywords.vue' 

import appList from './components/appList.vue' 

//import appDetails from './components/appDetails.vue' 
import appFooter from './components/appFooter.vue' 
import appPaging from './components/appPaging.vue'

export default {

  components: {

    'appHeader': appHeader,
    'appGenre': appGenre,
    'appConnection': appConnection,

    'appInput' : appInput,
    'appKeywords': appKeywords,

    'appList' : appList,
 //   'appDetails': appDetails,

    'appPaging': appPaging,
    'appFooter' : appFooter

  },


  data: function() {

    return {

      /******* 책 관련 배열 ******/

      shelf: [],
      tempBooks: [],
      currentBooks: [],
      recommendBooks: [],


      /********* 장르 컴포넌트 작동 ********/
      genreIsActive: [

        { id:0, isActive: true },
        { id:1, isActive: false },
        { id:2, isActive: false },
        { id:3, isActive: false },
        { id:4, isActive: false }
      ],

      /********* 키워드 **********/

      defaultkeywords: [

        {id:100, keyword:'전체보기', isActive:true, canBedeleted:false },
        {id:200, keyword:'추천도서', isActive:false, canBedeleted:false }

      ],
 
      recommendkeywords: [],

      teennovelKeywords: [

        { id:0, keyword:'우정', isActive:false, canBedeleted:false },
        { id:1, keyword:'연애', isActive:false, canBedeleted:false },
        { id:2, keyword:'짝사랑', isActive:false, canBedeleted:false },
        { id:3, keyword:'첫사랑', isActive:false, canBedeleted:false },
        { id:4, keyword:'가족', isActive:false, canBedeleted:false },
        { id:5, keyword:'한부모가정', isActive:false, canBedeleted:false },
        { id:6, keyword:'가족해체', isActive:false, canBedeleted:false },
        { id:7, keyword:'이혼', isActive:false, canBedeleted:false },
        { id:8, keyword:'입양', isActive:false, canBedeleted:false },
        { id:9, keyword:'모험', isActive:false, canBedeleted:false },
        { id:10, keyword:'진로', isActive:false, canBedeleted:false },
        { id:11, keyword:'진학', isActive:false, canBedeleted:false },
        { id:12, keyword:'여행', isActive:false, canBedeleted:false },
        { id:13, keyword:'미혼모', isActive:false, canBedeleted:false },
        { id:14, keyword:'가난', isActive:false, canBedeleted:false },
        { id:15, keyword:'왕따', isActive:false, canBedeleted:false },
        { id:16, keyword:'학교폭력', isActive:false, canBedeleted:false },
        { id:17, keyword:'자살', isActive:false, canBedeleted:false },
        { id:18, keyword:'인종차별', isActive:false, canBedeleted:false },
        { id:19, keyword:'2차대전', isActive:false, canBedeleted:false },
        { id:20, keyword:'디스토피아', isActive:false, canBedeleted:false },
        { id:21, keyword:'한국', isActive:false, canBedeleted:false },
        { id:22, keyword:'미국', isActive:false, canBedeleted:false },
        { id:23, keyword:'영국', isActive:false, canBedeleted:false },
        { id:24, keyword:'일본', isActive:false, canBedeleted:false },
        { id:25, keyword:'독일', isActive:false, canBedeleted:false },
        { id:26, keyword:'프랑스', isActive:false, canBedeleted:false }
        
      ],
           
      scifiKeywords: [

        { id:0, keyword: '외계 생명체',isActive:false, canBedeleted:false },
        { id:1, keyword: '우주 전쟁',isActive:false, canBedeleted:false },
        { id:2, keyword: '인공지능',isActive:false, canBedeleted:false },
        { id:3, keyword: '안드로이드',isActive:false, canBedeleted:false },
        { id:4, keyword: '시간여행',isActive:false, canBedeleted:false },
        { id:5, keyword: '바이러스',isActive:false, canBedeleted:false },
        { id:6, keyword: '초능력',isActive:false, canBedeleted:false },
        { id:7, keyword: '계급',isActive:false, canBedeleted:false },
        { id:8, keyword: '전쟁',isActive:false, canBedeleted:false },
        { id:9, keyword: '종말',isActive:false, canBedeleted:false },
        { id:10, keyword: '우주 탐사',isActive:false, canBedeleted:false },
        { id:11, keyword:'신', isActive:false, canBedeleted:false },
        { id:12, keyword:'테러', isActive:false, canBedeleted:false },
        { id:13, keyword:'화성', isActive:false, canBedeleted:false },
        { id:14, keyword:'달', isActive:false, canBedeleted:false },
        { id:15, keyword:'포스트 아포칼립스', isActive:false, canBedeleted:false },
        { id:16, keyword:'디스토피아', isActive:false, canBedeleted:false },
        { id:17, keyword:'유토피아', isActive:false, canBedeleted:false },
        { id:18, keyword:'통제사회', isActive:false, canBedeleted:false },
        { id:19, keyword:'스타크래프트', isActive:false, canBedeleted:false },
        { id:20, keyword:'하드SF', isActive:false, canBedeleted:false },
        { id:21, keyword:'스페이스 오페라', isActive:false, canBedeleted:false },
        { id:22, keyword:'게임 소설', isActive:false, canBedeleted:false },
        { id:23, keyword:'영화원작', isActive:false, canBedeleted:false },
        { id:24, keyword:'드라마원작', isActive:false, canBedeleted:false },
        { id:25, keyword:'애니원작', isActive:false, canBedeleted:false },
        { id:26, keyword:'시리즈', isActive:false, canBedeleted:false },
        
        
      ],

      fantasyKeywords: [
        { id:0, keyword: '이세계', isActive:false, canBedeleted:false },
        { id:1, keyword: '공간이동',isActive:false, canBedeleted:false },
        { id:2, keyword: '종족전쟁',isActive:false, canBedeleted:false },
        { id:3, keyword: '왕위쟁탈',isActive:false, canBedeleted:false },
        { id:4, keyword: '컨테이너 은유',isActive:false, canBedeleted:false },
        { id:5, keyword: '뱀파이어',isActive:false, canBedeleted:false },
        { id:6, keyword: '마법사',isActive:false, canBedeleted:false },
        { id:7, keyword: '늑대인간',isActive:false, canBedeleted:false },
        { id:8, keyword: '드래곤',isActive:false, canBedeleted:false },
        { id:9, keyword: '괴물',isActive:false, canBedeleted:false },
        { id:10, keyword: '천사',isActive:false, canBedeleted:false },
        { id:11, keyword:'오크', isActive:false, canBedeleted:false },
        { id:12, keyword:'요정', isActive:false, canBedeleted:false },
        { id:13, keyword:'악마', isActive:false, canBedeleted:false },
        { id:14, keyword:'', isActive:false, canBedeleted:false },
        { id:15, keyword:'초능력', isActive:false, canBedeleted:false },
        { id:16, keyword:'퇴마', isActive:false, canBedeleted:false },
        { id:17, keyword:'오컬트', isActive:false, canBedeleted:false },
        { id:18, keyword:'오브제', isActive:false, canBedeleted:false },
        { id:19, keyword:'책', isActive:false, canBedeleted:false },
        { id:20, keyword:'죽음', isActive:false, canBedeleted:false },
        { id:21, keyword:'학교', isActive:false, canBedeleted:false },
        { id:22, keyword:'게임소설', isActive:false, canBedeleted:false },
        { id:23, keyword:'영화원작', isActive:false, canBedeleted:false },
        { id:24, keyword:'드라마원작', isActive:false, canBedeleted:false },
        { id:25, keyword:'애니원작', isActive:false, canBedeleted:false },
        { id:26, keyword:'시리즈', isActive:false, canBedeleted:false },
      
      ],


      socialwelfareKeywords: [

        { id:0, keyword: '불평등',isActive:false, canBedeleted:false },
        { id:1, keyword: '빈곤',isActive:false, canBedeleted:false },
        { id:2, keyword: '복지국가',isActive:false, canBedeleted:false },
        { id:3, keyword: '고령화',isActive:false, canBedeleted:false },
        { id:4, keyword: '양극화',isActive:false, canBedeleted:false },
        { id:5, keyword: '신자유주의',isActive:false, canBedeleted:false },
        { id:6, keyword: '주거',isActive:false, canBedeleted:false },
        { id:7, keyword: '계급',isActive:false, canBedeleted:false },
        { id:8, keyword: '노인',isActive:false, canBedeleted:false },
        { id:9, keyword: '청년',isActive:false, canBedeleted:false },
        { id:10, keyword: '착취',isActive:false, canBedeleted:false },
        { id:11, keyword:'능력주의', isActive:false, canBedeleted:false },
        { id:12, keyword:'민영화', isActive:false, canBedeleted:false },
        { id:13, keyword:'정책', isActive:false, canBedeleted:false },
        { id:14, keyword:'프레임', isActive:false, canBedeleted:false },
        { id:15, keyword:'칼 폴라니', isActive:false, canBedeleted:false },
        { id:16, keyword:'장애', isActive:false, canBedeleted:false },
        { id:17, keyword:'인터뷰', isActive:false, canBedeleted:false },
        { id:18, keyword:'에스노그라피', isActive:false, canBedeleted:false },
        { id:19, keyword:'참여관찰', isActive:false, canBedeleted:false },
        { id:20, keyword:'한국', isActive:false, canBedeleted:false },
        { id:21, keyword:'미국', isActive:false, canBedeleted:false },
        { id:22, keyword:'영국', isActive:false, canBedeleted:false },
        { id:23, keyword:'일본', isActive:false, canBedeleted:false },
        { id:24, keyword:'스웨덴', isActive:false, canBedeleted:false },
        { id:25, keyword:'북유럽', isActive:false, canBedeleted:false },
        { id:26, keyword:'아프리카', isActive:false, canBedeleted:false }

      ],

/*************************************************************************************************** */

      searchIsActive: false,
      currentKeywords: [],

      allPages: [],
      currentPage: 1,
      maxbooksApage: 10,    

    }

  },


  methods: {

    /***************콤포넌트 이동 ****************/
     resetGenreButton: function() {

       this.genreIsActive[0].isActive = false;
       this.genreIsActive[1].isActive = false;
       this.genreIsActive[2].isActive = false;
       this.genreIsActive[3].isActive = false;
       this.genreIsActive[4].isActive = false;
       
     },

    /******************** 청소년 소설 장르 클릭시 *****************************/

    moveToteen: function() {

      this.resetGenreButton();
      this.genreIsActive[0].isActive = true;
      
     var vm = this;

      console.log("This App Begins");

       axios.get('https://gist.githubusercontent.com/pain543/c22ab59c2a1df758842f13a01cccc499/raw/c6a9047a5cad2e057926e7d4887e849a82584e09/teennovel.json')

          .then(function(response) {

          vm.shelf = response.data;
          vm.tempBooks = vm.shelf;

          vm.recommendkeywords = [];
          vm.recommendkeywords = vm.teennovelKeywords;

          vm.cancleDefaultkeyword();
          
          //전체 페이지
          vm.allPages = vm.calculateAllpages(vm.shelf.length);

          vm.showRecommendbooks_init();
          vm.fetchData_init();
          
         // vm.currentKeywords.push('전체보기');
         
        })
      
        .catch(function(error) {
          console.log(error);
        }); 
      

    },

/******************** 과학 소설 클릭시 ********************************/

    moveToscifi: function() {

      this.resetGenreButton();
      this.genreIsActive[1].isActive = true;

        var vm = this;

      console.log("Scifi Begins");

       axios.get('https://gist.githubusercontent.com/pain543/5312de5fe1a54ef6eeaa3fe5e9fe3a5c/raw/2faf45ecfe4249f1e4b36dcf9634713233e71cf5/scifi.json')
          .then(function(response) {

          vm.shelf = response.data;
          vm.tempBooks = vm.shelf;

          vm.recommendkeywords = [];
          vm.recommendkeywords = vm.scifiKeywords;

          vm.cancleDefaultkeyword();
          
          //전체 페이지
          vm.allPages = vm.calculateAllpages(vm.shelf.length);

          vm.showRecommendbooks_init();
          vm.fetchData_init();
          // vm.currentKeywords.push('전체보기');
         
        })
      
        .catch(function(error) {
          console.log(error);
        });

      
    },

/******************************** 환상소설 장르 클릭시*************************************/

moveTofantasy: function() {

      this.resetGenreButton();
      this.genreIsActive[2].isActive = true;

        var vm = this;      

      console.log("Fantasy Begins");

       axios.get('https://gist.githubusercontent.com/pain543/f832be604c05a1bbe1139efe9d55beaf/raw/c042290127925b7b9da70d5154f7b55846d233a1/fantasy.json')
          .then(function(response) {

          vm.shelf = response.data;
          vm.tempBooks = vm.shelf;

          vm.recommendkeywords = [];
          vm.recommendkeywords = vm.fantasyKeywords;

          vm.cancleDefaultkeyword();
          
          //전체 페이지
          vm.allPages = vm.calculateAllpages(vm.shelf.length);

          vm.showRecommendbooks_init();
          vm.fetchData_init();
          // vm.currentKeywords.push('전체보기');
         
        })
      
        .catch(function(error) {
          console.log(error);
        });

      
    },


/***************************************************************************************/

/*************************** 추리소설 장르 클릭시 ***************************************/


/*
moveTodetective: function() {

      this.resetGenreButton();
      this.genreIsActive[3].isActive = true;

        var vm = this;

      console.log("Detective Begins");

       axios.get('여기에 기스트 주소를 넣어라. json형식이다')
          .then(function(response) {

          vm.shelf = response.data;
          vm.tempBooks = vm.shelf;

          vm.recommendkeywords = [];
          vm.recommendkeywords = vm.scifiKeywords;

          vm.cancleDefaultkeyword();
          
          //전체 페이지
          vm.allPages = vm.calculateAllpages(vm.shelf.length);

          vm.showRecommendbooks_init();
          vm.fetchData_init();
          // vm.currentKeywords.push('전체보기');
         
        })
      
        .catch(function(error) {
          console.log(error);
        });

      
    },


*/


/************************************************************************************/

/******************** 논픽션(사회복지) 장르 클릭시 *****************************/
    moveTosocial: function() {

      this.resetGenreButton();
      this.genreIsActive[4].isActive = true;

        var vm = this;

      console.log("SocialWelfare Begins");

       axios.get('https://gist.githubusercontent.com/pain543/7a433b6ed0b07d596e71e377edd93edc/raw/f2bf4f6543dfe3b7abf2eb67c64a0f753fc20825/socialwelfare.json')
          .then(function(response) {

          vm.shelf = response.data;
          vm.tempBooks = vm.shelf;

          vm.recommendkeywords = [];
          vm.recommendkeywords = vm.socialwelfareKeywords;

          vm.cancleDefaultkeyword();
          
          //전체 페이지
          vm.allPages = vm.calculateAllpages(vm.shelf.length);

          vm.showRecommendbooks_init();
          vm.fetchData_init();
          // vm.currentKeywords.push('전체보기');
         
        })
      
        .catch(function(error) {
          console.log(error);
        });


    },


/********************* 페이지 관련 함수 시작********************/
    initCurrentpage: function() {

      this.currentPage = 1;

    },

    minusCurrentpage: function() {

      if(this.currentPage != 1) {

        this.currentPage = this.currentPage - 1;
        this.fetchData(this.currentPage);

      }

    },

    plusCurrentpage: function() {

      if(this.currentPage < this.allPages) {

          this.currentPage = this.currentPage + 1;
           this.fetchData(this.currentPage);

      }

    },

    goFirstpage: function() {

      this.currentPage = 1;
      this.fetchData(this.currentPage);

    },

    goLastpage: function() {

      this.currentPage = this.allPages;
      this.fetchData(this.currentPage);

    },
/****************** 페이지 관련 함수 끝 ***********************/


/***************** 무슨 함수 인지 까먹음 *********************/
    showInputBox: function() {

      console.log("실행됩니까");
    this.searchIsActive = !this.searchIsActive;

    },

/************************************************************/


    clickRecommendKeyword: function(keyword) {

      /*전체보기 버튼 음영 삭제*/
      this.cancleDefaultkeyword();
      
      for(var i=0; i<this.recommendkeywords.length; i++) {

        if(this.recommendkeywords[i].id == keyword.id) {
          this.recommendkeywords[i].isActive = true;
          console.log("키워드의 상태는 어떻습니까", this.recommendkeywords.isActive);
        }

        else { this.recommendkeywords[i].isActive = false;}
        
      }

      this.searchBooks(keyword.keyword);

    },


    searchBooks: function(keyword) {     

          let cart = []; 
          
          console.log(keyword,"에 해당하는 책 주세요!");
          console.log("ISBN의 자료형은? ");
          console.log(typeof this.shelf[1].ISBN);

        //  console.log(this.books.length);
        //  console.log(this.books[1].keywords.length);                 
        
          for(var i=0; i<this.shelf.length; i++) {     
              if(this.shelf[i].id == keyword) { cart.push(this.shelf[i]); continue; }
              if(this.shelf[i].title == keyword) { cart.push(this.shelf[i]); continue; }
              if(this.shelf[i].author == keyword) { cart.push(this.shelf[i]);continue; }
              if(this.shelf[i].translator == keyword) { cart.push(this.shelf[i]); continue; }
              if(this.shelf[i].publisher == keyword) { cart.push(this.shelf[i]); continue; }
              if(this.shelf[i].years == keyword) { cart.push(this.shelf[i]); continue; }
              if(this.shelf[i].pages == keyword) { cart.push(this.shelf[i]); continue; }
            //  if(this.shelf[i].nob == keyword) { cart.push(this.shelf[i]); continue; }
              if(this.shelf[i].ISBN == keyword) { cart.push(this.shelf[i]); continue; }
              if(this.shelf[i].fob == keyword) { cart.push(this.shelf[i]); continue; }
            //  if(this.shelf[i].nosr == keyword) { cart.push(this.shelf[i]); continue; }
              if(this.shelf[i].remark == keyword) { cart.push(this.shelf[i]); continue; }
            //  if(this.shelf[i].keywords == keyword) { cart.push(this.shelf[i]); continue; }
              
              for(var j=0; j<this.shelf[i].keywords.length; j++) {
                  if(this.shelf[i].keywords[j] === keyword) {
                      cart.push(this.shelf[i]);
                      break;
                  }
              }
          }
          
          this.tempBooks = []; 
          this.tempBooks = cart;

          console.log("이 키워드에 해당하는 책의 수", this.tempBooks.length);

          this.allPages = this.calculateAllpages(this.tempBooks.length);         
          this.initCurrentpage();
          
          this.fetchData(1);
          console.log("키워드 박스 뿌리기");

        
          this.pushCurrentKeywords(keyword); 
      
  },

    switchingImgAndSpec: function(book) {

      /*
      console.log(book.id, "이미지가 사라지길 바랍니다");
      book.isActive = !book.isActive;
      */
      
      console.log(book.id, "이미지가 사라지길 바랍니다");

      //book.isActive = !book.isActive;
      for(var i=0; i<this.tempBooks.length; i++) {

        if(this.tempBooks[i].id == book.id) {
          this.tempBooks[i].isActive = !book.isActive; 
           console.log('여기는 메인 컴포넌트, 지금 선택한 이미지의 번호는', this.tempBooks[i].id, "입니다.");
           console.log('여기는 메인 컴포넌트, 지금 선택한 이미지의 상태는', this.tempBooks[i].isActive, "입니다.");
           break;
        }

      }
      
    },

    cancleRecommendkeyword: function() {
    
        for(var i=0; i<this.recommendkeywords.length; i++) {

          this.recommendkeywords[i].isActive = false;

        }

    },


    cancleDefaultkeyword: function() {

        for(var i=0; i<this.defaultkeywords.length; i++) {
          this.defaultkeywords[i].isActive = false;
        }

    },

    showAllbooks: function(keyword) {

      
      this.cancleDefaultkeyword();
      this.cancleRecommendkeyword();

      this.defaultkeywords[0].isActive = true;
      
      console.log(keyword);
    /*this.tempBooks = this.shelf;
      this.currentKeywords = [];
      this.currentKeywords.push(keyword);
    */

      this.tempBooks = this.shelf;
      this.currentBooks = [];      
      this.allPages = this.calculateAllpages(this.shelf.length);

      for(var i=0; i<1*this.maxbooksApage;i++) {

            this.currentBooks.push(this.tempBooks[i]);
            
       }

       this.initCurrentpage();
          
      
    },

  
// 추천 키워드는 27개, 책키워드에서 올라오는 키워드는 1개
    handleRecommendKeywords: function(keyword) {

      this.cancleDefaultkeyword();

      let idx = this.recommendkeywords.indexOf(keyword);

      if(this.recommendkeywords.length > 27) {
          this.recommendkeywords.pop();
      }

      if(idx == -1) {
        
          console.log("키워드 중복 검사 중입니다 idx는", idx);

          for(var i=0; i<this.recommendkeywords.length; i++){
            this.recommendkeywords[i].isActive = false;
          }

          let obj = { id:28, keyword: '', isActive: null, canBedeleted:false };
          
          obj.isActive = true;
          obj.keyword = keyword;
          this.recommendkeywords.push(obj);
          
          this.searchBooks(keyword);

      }
      
    },


    // 간단한 메소드
    pushCurrentKeywords: function(keyword) {

        this.currentKeywords = [];
        this.currentKeywords.push(keyword);

    },


/* 사용안함
    checkDuplication: function(keyword) { 
     
      let idx = this.currentKeywords.indexOf(keyword);
      return idx;

    },
*/
    renewCurrentKeywords: function(keyword) {

      if(keyword.isActive == true) {      

        this.cancleRecommendkeyword();

      }
            
      this.showAllbooks('전체보기');

    },

      /*
      let idx = this.checkDuplication(keyword);
      if ( idx > -1 ) { 
          this.currentKeywords.splice(idx, 1);
          
      }

      console.log("키워드창의 길이는?", this.currentKeywords.length);
           
      if(this.currentKeywords.length === 0) { 
          this.showAllbooks('전체보기');
      }

      else {
        let idx2;
        for(var i=0; i<this.tempBooks.length; i++) {
            idx2 = this.tempBooks[i].keywords.indexOf(keyword);
            if(idx2 > -1 ) {
              console.log("제거될 책",this.tempBooks[i].title);
              delete this.tempBooks[i]
            }

        }
      }
      //배열에 속 undefined 제거하기
      this.tempBooks  = this.tempBooks.filter(function(item) {return item !== null && item !== undefined && item !== '';});
    
    }*/



    showRecommendbooks_init: function() {

      this.initCurrentpage();

      this.recommendBooks = [];

      for(var i=0; i<this.shelf.length;i++) {

      if(this.shelf[i].remark == "추천") {
          console.log("추천되었습니다");
          this.recommendBooks.push(this.shelf[i]);
        } 
 
      }
      
        
    },

    
    showRecommendbooks:function() {


      this.initCurrentpage();
      this.cancleRecommendkeyword();
      this.allPages = this.calculateAllpages(this.recommendBooks.length);
            
      if (this.defaultkeywords[1].isActive == true) {

        this.defaultkeywords[1].isActive = false;

        this.showAllbooks('전체보기');

      }
     
      else {
         this.cancleDefaultkeyword();
        this.defaultkeywords[1].isActive = true;     
        this.tempBooks = this.recommendBooks;

        this.fetchData(1);

      }
           

    },

/* 추천도서를 먼저 나오게 함 */

    fetchData_init: function() {   

      /*
      this.tempBooks = this.shelf;
      this.currentBooks = [];
      */
        
      /*
      for(var i=0; i<pageNumber*this.maxbooksApage;i++) {

            this.currentBooks.push(this.tempBooks[i]);
            
          }
      */

     this.showRecommendbooks();
                    
    }, 

    fetchData: function(pageNumber) {   

       console.log("페이지 입력이 들어왔습니다.")

      this.currentBooks = [];
        
      //for(var i=0; i<pageNumber*8;i++) {
      for(var i=((pageNumber-1)*this.maxbooksApage); i<pageNumber*this.maxbooksApage;i++) {

        if(i == this.tempBooks.length) {
          break;
        }

        else {
            this.currentBooks.push(this.tempBooks[i]);
        }
            
      }          
      
    }, 

    /* 총페이지 계산 함수*/
    calculateAllpages: function (length) {

      console.log("총 페이지 계산", Math.ceil(length/this.maxbooksApage));
      return Math.ceil(length/this.maxbooksApage);

    }

  },

  /*******************************************초기화 함수**************************************************/

    created: function() {

      var vm = this;

      console.log("This App Begins");

       axios.get('https://gist.githubusercontent.com/pain543/c22ab59c2a1df758842f13a01cccc499/raw/c6a9047a5cad2e057926e7d4887e849a82584e09/teennovel.json')
          .then(function(response) {

          vm.shelf = response.data;
          vm.tempBooks = vm.shelf;

          vm.recommendkeywords = vm.teennovelKeywords;
                    
          //전체 페이지
          vm.allPages = vm.calculateAllpages(vm.shelf.length);

          vm.showRecommendbooks_init();
          vm.fetchData_init();
          
         // vm.currentKeywords.push('전체보기');
         
        })
      
        .catch(function(error) {
          console.log(error);
        });
            
           
  }

}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;300;400;500;700;900&display=swap');

#app {

width: 1600px;

margin-left: auto;
margin-right: auto;
box-sizing: border-box;

font-family: 'Noto Sans KR', sans-serif;
color:#323335

}

/***** 헤더와 키워드보드 고정 *****/
.fixed {

  position: fixed;
  left:0;
  top:0;
  width:100%;
  z-index: 6; /* 드래그시 책표지 보다 위에 있음" */
  

}

.header {
 
  background-color: white;

  top: 0;

  width: 1500px;
  height: 70px;
  margin-left: auto;
  margin-right: auto;   

  margin-top:0px;  
  margin-bottom: 0px;

  
}

.logo {
  box-sizing: border-box;
  
  display:inline-block;
  
  text-align: center;
  width: 200px;
  margin-left: 10px;
  margin-right: 10px;
   

}

.genre {

  box-sizing: border-box;  
  
  display: inline-block;
  width: 1000px;

  margin-left: 10px;
  margin-right: 10px;
    
}

.connection {

  box-sizing: border-box;  

  display: inline-block;
  
  width: 180px;
  margin-left: 10px;
  margin-right: 10px;

}

.keyword {
  background-color: white;

  width: 1500px;
  height: 130px;
  
  margin-left: auto;
  margin-right: auto;   
  
  margin-bottom: 0px;

}

 .inputBox {
    
  display: block;
  height: 40px;
  width: 700px;
  padding-left:2px;
  padding-right:0px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
  border-radius: 10px;
  
 }

.keywordsBoard {

  box-sizing: border-box;
  
  width: 1000px;
    
  display: flex;
  flex-wrap: wrap;
  
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;

}

/* 책표지와 키워드가 표시되는 곳*/

.mainSection { 

     
  box-sizing: border-box;

  background-color: white;
  /*flex-wrap:wrap 창 줄였을때 어떻게 할것인가*/ 
  justify-content: center;
  align-items: flex-start; 

  width: 100%;

  margin-left: auto;
  margin-right: auto;   

  padding-top: 220px;

}


.bookBoard {

    display: block;  
    background-color: white;
    width: 1500px;
    padding-left: 10px;
    padding-right: 10px;
    margin-left: auto;
    margin-right: auto;

    box-sizing: border-box;
          
}

.pagination {

  display: flex;
  justify-content: center;
  height: 30px;
  width: 1160px;
  margin-top: -8px;
  margin-bottom: 10px;
  
}

.footer {
  
  box-sizing: border-box;  
  display: flex;

  width: 1500px;
  height: 35px;
  margin-left: auto;
  margin-right: auto;       

  background-color:#b1b1b1; 

}

</style>
